import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";

import KPIComparator from "components/visuals/KPIComparator";
import numberFormatter from "utils/numberFormatter";

import { useAppSelector } from "store";
import { selectStore, selectComparator } from "modules/customer/insights/portfolio/portfolioSlice";
import { selectors } from "modules/customer/insights/portfolio/areaHealth/openingsAndClosures";

const LifetimeOfStores = () => {
    const selectedStore = useAppSelector(selectStore);
    const selectedComparator = useAppSelector(selectComparator);
    const lifetimeOfStores = useSelector(state => selectors.lifetimeOfStores(state));
    const { loading, error, value, percentageDifference } = lifetimeOfStores;
    const valueFormatted = `${numberFormatter.toDecimalPlaces(value, 0)} months`;
    const label = `Shops in ${selectedStore.name} local area average lifetime vs the ${selectedComparator.name}`;

    return (
        <Box width="100%" height="100%" data-cy="lifetime-of-stores">
            <KPIComparator loading={loading} error={error} label={label} value={valueFormatted} percentage={percentageDifference} />
        </Box>
    );
};

export default LifetimeOfStores;
